import { validarSintaxis } from './validarSintaxis'
import { normalizaAlias } from './normalizaAlias'
import { parseExpression, normalizeNode, stringifyNode } from '../motor/ast'

function extraerMedidasImagen(contenido) {
  const match = String(contenido || '').match(/,\s*(\d+(?:\.\d+)?x\d+(?:\.\d+)?)\s*$/i)
  if (!match) return null

  const base = contenido.slice(0, match.index).trim()
  const size = match[1]
  if (!base) return null

  return { base, size }
}

function quitarTamanoImagen(expresion) {
  const match = String(expresion || '')
    .trim()
    .match(/^i:(.+?)(?:,\s*\d+(?:\.\d+)?x\d+(?:\.\d+)?)?$/i)

  if (!match) return String(expresion || '').trim()
  return `i:${match[1].trim()}`
}

/**
 * Normaliza todos los placeholders detectados y devuelve:
 * - lista normalizada
 * - errores detectados
 * - mapa expresiones finales por tag original
 */
export function normalizarPlaceholders(placeholders, variables, expresiones, errors = []) {
  const { aliasToVariable, aliasToExpresion, pathToVariable } = normalizaAlias(variables, expresiones)

  const resultados = []
  const errores = []
  const mapaFinal = {} // tagOriginal → expresionFinal

  for (const ph of placeholders) {
    const tag = ph.tag
    const contenido = ph.contenido.trim()
    const imagenConMedidas = extraerMedidasImagen(contenido)

    if (imagenConMedidas) {
      const ast = parseExpression(imagenConMedidas.base, errors)
      const norm = normalizeNode(ast, aliasToVariable, aliasToExpresion, pathToVariable, errors)
      const normalizado = stringifyNode(norm)

      if (!/^i:/.test(normalizado)) {
        errores.push({
          tag,
          error: 'Las medidas sólo se pueden aplicar a placeholders de imagen',
        })
        mapaFinal[tag] = tag
        continue
      }

      const expresionFinal = `\${${quitarTamanoImagen(normalizado)},${imagenConMedidas.size}}`
      mapaFinal[tag] = expresionFinal
      resultados.push({ original: tag, normalizado: expresionFinal, tipo: 'normalizado' })
      continue
    }

    // Validación inicial de sintaxis (básica)
    const sint = validarSintaxis(tag)
    if (!sint.ok) {
      errores.push({ tag, error: sint.error })
      mapaFinal[tag] = tag
      continue
    }

    const ast = parseExpression(tag, errors)
    const norm = normalizeNode(ast, aliasToVariable, aliasToExpresion, pathToVariable, errors)
    const normalizado = stringifyNode(norm)

    mapaFinal[tag] = `\${${normalizado}}`
    resultados.push({ original: tag, normalizado: mapaFinal[tag], tipo: 'normalizado' })
  }

  return {
    resultados,
    errores,
    mapaFinal,
  }
}
